'use client';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import {
  setAdGroupIdCookie,
  setAffiliatesCookie,
  setCookiesFromSearchParams,
  setGoogleClickIdCookie,
  setPartnerizeCookies,
  setReferrerCookie,
  setupImpactCookies,
} from './cookies';

export const TrackingCookies = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    setAdGroupIdCookie(searchParams);
    setGoogleClickIdCookie(searchParams);
    setAffiliatesCookie(searchParams);
    setPartnerizeCookies(searchParams);
    setupImpactCookies(searchParams);
    setReferrerCookie();
    setCookiesFromSearchParams(searchParams);
  }, [pathname, searchParams]);

  return null;
};
